export const SEARCH_CONFIG = {
  general: 'prod_pll_general',
  shop: 'shopify_products',
  players: 'prod_players',
  videos: 'prod_videos',
  posts: 'prod_articles',
  teams: 'prod_teams',
}
